<template>
  <div class="container-fluid">
    <v-card
      color="red"
      flat
      tile
    >
      <v-toolbar dense
                 src="https://c.pxhere.com/photos/97/7d/breakfast_coffee_delicious_dish_drinks_egg_food_meal-1534997.jpg!d"
      >
        <v-spacer></v-spacer>
      </v-toolbar>
    </v-card>
    <v-data-table
      :headers="headers"
      :items="menus"
      sort-by="internalName"
      class="elevation-1"
      :search="search"
      :items-per-page="-1"
      locale="cs"
      single-expand
      show-expand
      item-key="id"
      :loading="loading"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Archiv menu</v-toolbar-title>
          <v-divider
            class="mx-4"
            inset
            vertical
          ></v-divider>
          <v-spacer>Výpis</v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Vyhledávání"
            single-line
            hide-details
          ></v-text-field>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon
          class="mr-2"
          @click="extract(item)"
        >
          mdi-archive-arrow-up
        </v-icon>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="getMenus">Reset</v-btn>
      </template>
      <template v-slot:expanded-item="{ headers, item }">
          <b style="margin-right: 5px; margin-left: 5px">Položky:</b>
          <td :colspan="headers.length">
            <div v-for="(menuItem, index) in item.foods.concat(item.drinks)" :key="index">
              {{menuItem.name}}
            </div>
          </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  Name: 'MenuDatabase',
  data: () => ({
    loading: true,
    search: '',
    headers: [
      {
        text: 'Interní název',
        align: 'start',
        sortable: true,
        value: 'internalName'
      },
      { text: 'Název menu', value: 'name' },
      { text: 'Typ menu', value: 'typesStr' },
      { text: 'Denní doba', value: 'timesStr' },
      { text: 'Obsah menu', value: 'content' },
      { text: 'Alergeny', value: 'alergensStr' },
      { text: 'Cena', value: 'price' },
      { text: 'Objem', value: 'volume' },
      { text: 'Hmotnost', value: 'weight' },
      { text: 'Kalorie', value: 'calories' },
      { text: 'Archivováno dne', value: 'archivedAt' },
      { text: 'Akce', value: 'actions', sortable: false }
    ],
    menus: []
  }),
  created () {
    this.getMenus()
  },

  methods: {
    getMenus () {
      this.menus = []
      this.dialog = false
      this.loading = true
      this.$http.get('/admin/menus/archive')
        .then(response => {
          this.menus = this.keysToCamelCase(response.data)
            .filter(item => item.visible)
            .map(menu => {
              menu.timesStr = menu.timeTypes
                .map(time => time.name)
                .join(', ')
              menu.typesStr = menu.foodTypes
                .map(type => type.name)
                .join(', ')
              menu.alergensStr = menu.alergens
                .map(alergen => alergen.name)
                .join(', ')
              menu.content = menu.foods.concat(menu.drinks)
                .map(item => item.name)
                .join(', ')
              menu.volume = menu.drinks
                .map(drink => drink.volume)
                .join(', ')
              menu.archivedAt = menu.updatedAt.slice(0, 10)
              return menu
            })
          this.loading = false
        })
    },
    extract (item) {
      this.$http.post(`admin/menus/${item.id}/extract`)
        .then(() => {
          this.getMenus()
        })
    }
  }
}
</script>

<style scoped>

</style>
